var React = require('react');

function IconOsSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M514.7 63.6c-247.4.3-447.5 200.6-447.5 448 0 160.5 84.4 301.3 211.2 380.4 5 3.1 11.7 1.3 14.3-4l23.7-48c-.1 0-.1-.1-.2-.1l85.4-172.5h.1l24.9-50.5c2-4 1.1-8.8-2.3-11.8-25.8-23.2-42-56.8-42.3-94.2-.5-70.4 56.7-128.3 127.1-128.8 71.1-.5 128.9 57 128.9 128 0 35.5-14.5 67.7-37.9 90.9-3.2 3.2-3.9 8.1-1.7 12l27.6 48.8c.1-.1.2-.1.2-.2l97.3 172.2s-.1 0-.1.1l26.4 46.7c2.9 5 9.4 6.6 14.2 3.4 120-80.4 198.9-217.2 198.9-372.4.3-247.6-200.6-448.3-448.2-448z"}));
}

IconOsSolid.displayName = "IconOsSolid";

IconOsSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconOsSolid;

IconOsSolid.default = IconOsSolid;
